import React, { useState, useEffect } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "./Acasa.css";
import AOS from 'aos';
import 'aos/dist/aos.css';
import statie from "../assets/ITP auto-moto 4x4.jpg";
import { Helmet } from 'react-helmet';
import Breadcrumbs from '../components/Breadcrumbs';
import { FaCalendarCheck, FaStar, FaWrench, FaCar, FaMotorcycle, FaTruck } from 'react-icons/fa';

import { FaMapMarkerAlt, FaClock, FaPhoneAlt } from 'react-icons/fa';

AOS.init({
  duration: 1000,
  once: true
});

const Acasa = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const googleReviewLink = "https://www.google.com/search?q=ITP+Soseaua+Electronicii+26+reviews";
  const placeName = "ITP Soseaua Electronicii 24";
  const rating = 5.0;
  const reviewCount = "4.8";

  const prices = [
    {
      type: "Autoturisme",
      icon: <FaCar className="price-icon" />,
      price: "200 - 250 RON",
      description: "ITP pentru vehicule sub 3.5 tone, inclusiv autoturisme și SUV-uri."
    },
    {
      type: "Motociclete & ATV",
      icon: <FaMotorcycle className="price-icon" />,
      price: "200 RON",
      description: "Inspecție tehnică periodică pentru motociclete, scutere și ATV-uri."
    },
    {
      type: "Vehicule Utilitare",
      icon: <FaTruck className="price-icon" />,
      price: "250 - 350 RON",
      description: "ITP pentru autoutilitare, microbuze și alte vehicule comerciale ușoare."
    },
  ];

  const itpServices = [
    {
      title: "Verificare rapidă și eficientă",
      description: "Asigură-te că mașina ta este în condiții optime cu o verificare ITP rapidă și fără bătăi de cap. Centrele partenere folosesc echipamente de ultimă generație pentru o inspecție precisă.",
      image: "https://images.pexels.com/photos/4315572/pexels-photo-4315572.jpeg",
      buttonText: "Vezi centrele disponibile",
      buttonLink: "#centre"
    },
    {
      title: "Programare online, fără stres",
      description: "Uită de cozile lungi și de telefoanele ocupate! Programează-ți ITP-ul direct de pe site, la ora și locația care îți convine cel mai mult. Primești confirmare instant și memento-uri utile.",
      image: "https://images.pexels.com/photos/3807329/pexels-photo-3807329.jpeg",
      buttonText: "Programează acum",
      buttonLink: "#programare"
    },
    {
      title: "Verificari periodice",
      description: "Nu mai rata niciodată data expirării ITP-ului! Platforma noastră îți trimite notificări personalizate prin SMS sau email, astfel încât să fii mereu la curent și să eviți amenzile.",
      image: "https://images.pexels.com/photos/104836/speed-car-vehicle-drive-104836.jpeg",
      buttonText: "Află mai multe",
      buttonLink: "#notificari"
    }
  ];

  const nextSlide = () => {
    setCurrentSlide((prevSlide) => (prevSlide + 1) % itpServices.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prevSlide) => (prevSlide - 1 + itpServices.length) % itpServices.length);
  };

  useEffect(() => {
  const slideInterval = setInterval(nextSlide, 6000);
  return () => clearInterval(slideInterval);
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [currentSlide]);

  return (
    <div className="page-wrapper">   
      <Helmet>
        <title>ITP Sector 2 București | Auto, Moto, ATV – Șoseaua Electronicii 24</title>
        <meta name="description" content="ITP Auto Moto Sector 2 – Verificare tehnică rapidă și sigură pe Șoseaua Electronicii 24. Servicii pentru toate tipurile de vehicule!" />
      </Helmet>

      <Navbar />
      <Breadcrumbs />

      <main className="acasa-main">
        {/* HERO SECTION */}
        <section className="itp-hero-section">
          <div className="hero-background-overlay"></div>
          <div className="hero-content" data-aos="fade-up">
            <h1 className="hero-title">ITP Șoseaua Electronicii 24</h1>
            <p className="hero-subtitle">Stație ITP autorizată, Sector 2, București. Servicii </p>
          </div>

          <div className="hero-features-card" data-aos="fade-up" data-aos-delay="200">
            <div className="feature-item">
              <div className="feature-icon-wrapper">
                <FaCalendarCheck className="feature-icon" />
              </div>
              <h4>ITP Urgent?</h4>
              <p>Fără programare prealabilă</p>
            </div>
            <div className="feature-item">
              <div className="feature-icon-wrapper">
                <FaStar className="feature-icon" />
              </div>
              <h4>Serviciu 5 Stele</h4>
              <p>Bazat pe recenzii reale</p>
            </div>
            <div className="feature-item">
              <div className="feature-icon-wrapper">
                <FaWrench className="feature-icon" />
              </div>
              <h4>Experiență</h4>
              <p>Peste 5 ani în domeniu</p>
            </div>
          </div>
        </section>

         {/* Locatie Harta */}
        <section className="statie-locatie-section" data-aos="fade-up">
<div className="locatie-header">
  <div className="locatie-title">
    <div className="marker-badge">
      <FaMapMarkerAlt />
    </div>

    <h2>Vă așteptăm în stația ITP Sector 2 – Șoseaua Electronicii 24</h2>
  </div>
</div>

      <div className="locatie-grid-container">
        {/* Partea Stângă: Harta embedded sau imaginea hărții */}
        <div className="locatie-map-wrapper">
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2848.0892499818406!2d26.133348475701975!3d44.45184110041348!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40b1f93adb46ee6f%3A0xc09bdfc48ce80892!2sStatie%20ITP%20Auto-Moto-ATV-Camioane!5e0!3m2!1sro!2sro!4v1783673664484!5m2!1sro!2sro" 
          title="Locatie statie ITP Soseaua Electronicii 24"
          width="600" 
          height="450" 
          style={{border:0}}
          allowfullscreen="" 
          loading="lazy" 
          referrerpolicy="strict-origin-when-cross-origin">
          </iframe>
        </div>

        {/* Partea Dreaptă: Detaliile Text */}
        <div className="locatie-info-content">
          <div className="location-title-group">

            <h3>ITP Șoseaua Electronicii 24</h3>
          </div>

          <p className="locatie-text">
            Vă așteptăm pentru verificarea ITP la sediul nostru modern din București, sector 2. 
          </p>
          
          <p className="locatie-text-directions">
            <strong>Indicații de acces:</strong> Accesul la stația ITP sector 2 se face direct din Șoseaua Electronicii 26. După ce intri în curte, urmezi indicatoarele către hala ITP. Stația este accesibilă direct cu mașina și există spațiu pentru a aștepta la rând..
          </p>

          <div className="program-card">
            <div className="program-icon">
              <FaClock />
            </div>
            <div className="program-details">
              <h4>Program de funcționare:</h4>
              <p><span>Luni – Vineri:</span> 08:00 – 19:30</p>
              <p><span>Sâmbătă:</span> 08:00 – 13:30</p>
            </div>
          </div>

          <div className="locatie-cta-actions">
            <a href="tel:+40726104358" className="btn-locatie-call">
              <FaPhoneAlt className="btn-icon" /> Sună Acum
            </a>
          </div>
        </div>
      </div>
    </section>

        {/* COMBINED INFO SECTION */}
        <section className="itp-combined-section" data-aos="fade-up">
          <div className="left-column">
            <h2 className="section-title">Stație ITP Auto, Moto & ATV – Sector 2</h2>
            <p className="description">
              Vă așteptăm la stația noastră ITP situată în Sector 2, pe Șoseaua Electronicii nr. 24, pentru efectuarea inspecției tehnice periodice a vehiculului dumneavoastră – chiar și fără programare prealabilă.
            </p>
            <h3 className="section-subtitle">Categorii vehicule verificate:</h3>
            <ul className="modern-list">
              <li>Motociclete, ATV-uri și tricicluri</li>
              <li>Autoturisme (Benzină / GPL / CNG / Diesel)</li>
              <li>Autoutilitare &lt; 3.5t și &gt; 3.5t & Autobuze</li>
            </ul>
            <a href="/Contact" className="btn-modern-primary">Programează ITP Acum</a>
          </div>

          <div className="right-column">
            <img src={statie} alt="Statie ITP" className="itp-image" />
            <div className="text-overlay">
              <h3>Rapid și Simplu</h3>
              <p>Verifici prețul, te prezinți la stație și pleci în siguranță, fără cozi.</p>
              <a href="tel:+40726104358" className="btn-modern-secondary">Sună Acum</a>
            </div>
          </div>
        </section>

        {/* SEO SCHEDULE SECTION */}
        {/* <section className="contact-seo-content" data-aos="fade-up">
          <h2>Program Complet ITP Sector 2</h2>
          <p>Disponibili <strong>Luni-Vineri: 09:00 - 19:30</strong> și <strong>Sâmbătă: 08:00 - 13:30</strong>.</p>
          <p>Pentru urgențe sau detalii rapide, nu ezitați să ne contactați sau să vizitați stația din Șoseaua Electronicii nr. 24.</p>
          <a className="btn-modern-outline" href="/contact">Vezi Orar & Programări</a>
        </section> */}

        {/* CAROUSEL SECTION */}
        <section className="carousel-section" data-aos="fade-up">
          <div className="carousel-container">
            {itpServices.map((service, index) => (
              <div
                key={index}
                className={`carousel-slide ${index === currentSlide ? "active" : ""}`}
                style={{ backgroundImage: `linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.6)), url(${service.image})` }}
              >
                <div className="carousel-content">
                  <h3>{service.title}</h3>
                  <p>{service.description}</p>
                  <a href={service.buttonLink} className="btn-modern-primary">{service.buttonText}</a>
                </div>
              </div>
            ))}
            <button className="carousel-arrow left" onClick={prevSlide}>&#10094;</button>
            <button className="carousel-arrow right" onClick={nextSlide}>&#10095;</button>
          </div>
        </section>

        {/* PRICE SECTION */}
        <section className="price-section" data-aos="fade-up">
          <div className="price-section-header">
            <h2>Tarife Transparente ITP</h2>
            <p>Prețuri corecte și competitive, fără costuri ascunse.</p>
          </div>
          <div className="price-cards-container">
            {prices.map((item, index) => (
              <div className="price-card" key={index}>
                <div className="price-icon-wrapper">{item.icon}</div>
                <h3>{item.type}</h3>
                <div className="price-value">{item.price}</div>
                <p>{item.description}</p>
                <a href="tel:+40726104358" className="btn-card-action">Programează</a>
              </div>
            ))}
          </div>
        </section>

                {/* GOOGLE REVIEWS BANNER */}
        <section className="google-reviews-banner" data-aos="fade-up">
          <div className="banner-content">
            <img src="https://upload.wikimedia.org/wikipedia/commons/2/2f/Google_2015_logo.svg" alt="Google" className="google-logo" />
            <div className="rating-section">
              <span className="rating-score">{rating.toFixed(1)}</span>
              <div className="stars">
                {[...Array(5)].map((_, i) => <FaStar key={i} className="star-icon filled" />)}
              </div>
              <span className="review-count">({reviewCount} / 5 din recenzii)</span>
            </div>
            <p className="banner-text">Vedeți ce spun clienții noștri despre serviciile de ITP la {placeName}.</p>
            <a href={googleReviewLink} target="_blank" rel="noopener noreferrer" className="btn-modern-outline">
              Lasă o recenzie pe Google
            </a>
          </div>
        </section>

        {/* WIDGET REVIEWS */}
        <section className="widget-reviews-section" data-aos="fade-up">
          <div className="sk-ww-google-reviews" data-embed-id="25581004"></div>
          <iframe src="https://widgets.sociablekit.com/google-reviews/iframe/25581004" frameBorder="0" width="100%" height="600" title="Google Reviews"></iframe>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default Acasa;